export default __webpack_public_path__ + "static/media/021-bump.5b691775.png";